module.exports = __webpack_public_path__ + "5acf09f73541933301e6a6adab9b341d.jpg";